const isNullOrWhiteSpace = (input: Nullable<string>): boolean => {
  if (typeof input === 'undefined' || input == null) return true;
  return String(input).replace(/\s+$/g, '').length < 1;
};

export const hasValue = (input: Nullable<string>): boolean => {
  return !isNullOrWhiteSpace(input);
};
